
/* MAIN */

const TOKEN_TYPE = <const> {
  SELECTOR: 1,
  BODY_START: 2,
  BODY_END: 3
};

/* EXPORT */

export {TOKEN_TYPE};
